module.exports = __webpack_public_path__ + "static/Forager4-c6d83e79ec7bcfce8c3760a32d4e88c1.webp";